import { BASE_END_POINT } from "../../parametros";
import i18n from "i18next";
import { StatusJogoDTO } from "../dtos/StatusJogoDTO";

async function retornarStatusJogo(): Promise<StatusJogoDTO> {

    const url = `${BASE_END_POINT}/api-v1/jogoonline/status`;

    const response = await fetch(url, {
        headers: { 'Accept-Language': i18n.language }
    });

    if (!response.ok) {
        throw new Error(`Erro ao buscar status do jogo. Código: ${response.status}`);
    }

    return await response.json() as StatusJogoDTO;
}

export {
    retornarStatusJogo
};
